import { DEFAULT_PINNED_METRICS, METRICS, type MetricKey } from "./metrics";

const KNOWN = new Set<string>(METRICS.map((metric) => metric.key));

const isMetricKey = (key: string): key is MetricKey => KNOWN.has(key);

export const resolvePins = (saved: string[] | null | undefined): MetricKey[] => {
  if (!saved) return DEFAULT_PINNED_METRICS;
  return [...new Set(saved.filter(isMetricKey))];
};

export const applyPinSelection = (pins: MetricKey[], selected: ReadonlySet<string>): MetricKey[] => {
  const kept = pins.filter((pin) => selected.has(pin));
  const added = METRICS.map((metric) => metric.key).filter((key) => selected.has(key) && !pins.includes(key));
  return [...kept, ...added];
};

const KEY_OFFSETS: Record<string, (columns: number) => number> = {
  ArrowLeft: () => -1,
  ArrowRight: () => 1,
  ArrowUp: (columns) => -columns,
  ArrowDown: (columns) => columns,
};

export const isReorderKey = (key: string): boolean => key in KEY_OFFSETS;

export const movePinByKey = (pins: MetricKey[], pin: MetricKey, key: string, columns: number): MetricKey[] => {
  const offset = KEY_OFFSETS[key]?.(columns);
  const from = pins.indexOf(pin);
  if (offset === undefined || from < 0) return pins;
  const to = from + offset;
  if (to < 0 || to >= pins.length) return pins;
  const next = pins.filter((entry) => entry !== pin);
  next.splice(to, 0, pin);
  return next;
};
